<div class="login-page" [@routerTransition]>
    <div id="overlay2"></div>
    <div id="page-signin-bg">
        <div class="overlay"></div>
        <!-- Background overlay -->
        <img src="assets/images/ts_admin_bg.jpg" alt="" />
        <!-- img src="http://static.teamstreamz.com/static/ts_admin_bg.jpg"-->
    </div>
    <!-- / Page background -->

    <div class="signin-container">
        <div class="signin-info">
            <!-- Left side -->
            <img src="assets/images/StreamzAI-logo-white.png" width="178px" alt="" />
            <div class="slogan">
                Inform. Involve. Empower. <br />
                <br /><br />
                Intelligent interventions platform to supercharge your sales
            </div>
            <!-- / .slogan -->
        </div>
        <!-- / Left side -->

        <div class="signin-form">
            <!-- Right side / Signin Form -->
            <!-- font size="4" face="Arial" color="Red" id="warning">{{warning}}</font-->
            <!-- Place Holder for Warnings -->

            <div class="signin-text">
                <span>Sign In to your account</span>
            </div>
            <!-- / .signin-text -->

            <app-alert></app-alert>

            <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
                <div class="form-group w-icon">
                    <!--input type="text" id="Username" name="Username" class="form-control input-lg" placeholder="Username or email" onkeydown="if (event.keyCode == 13) { triggerLogin(); return false; }"-->
                    <input
                        type="text"
                        id="Username"
                        formControlName="email"
                        class="form-control input-lg"
                        placeholder="Email"
                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                    />
                    <span class="fa fa-user signin-form-icon"></span>
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required</div>
                    </div>
                </div>
                <div class="form-group w-icon">
                    <!--input type="password" id="Password" name="Password" class="form-control input-lg" placeholder="Password" onkeydown="if (event.keyCode == 13) { triggerLogin(); return false; }"-->
                    <input
                        type="password"
                        id="Password"
                        formControlName="password"
                        class="form-control input-lg"
                        placeholder="Password"
                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                    />
                    <span class="fa fa-lock signin-form-icon"></span>
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                </div>
                <div class="form-actions">
                    <button [disabled]="loading" class="btn signin-btn bg-primary">SIGN IN</button>
                    <img
                        *ngIf="loading"
                        class="ps-3"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                    />
                    <a (click)="flipForm()" class="forgot-password" id="forgot-password-link"
                        >Forgot your password?</a
                    >
                    <!--a *appHideProd routerLink="/register" class="btn btn-link">Register</a-->
                </div>
            </form>

            <div [@fadeInOut]="animationState" id="password-reset-form" class="password-reset-form">
                <!-- Forgot Password Form -->
                <div class="header">
                    <div class="signin-text">
                        <span>Password reset</span>
                        <div class="close" (click)="flipForm()">&times;</div>
                    </div>
                    <!-- / .signin-text -->
                </div>
                <!-- / .header -->
                <app-alert></app-alert>
                <form [formGroup]="pwdChangeForm" (ngSubmit)="onPwdChangeSubmit()">
                    <div class="form-group w-icon" style="margin-bottom: 45px">
                        <!--input type="text" id="p_email_id" class="form-control input-lg" placeholder="Enter your email"-->
                        <input
                            type="text"
                            formControlName="emailid"
                            class="form-control input-lg"
                            placeholder="Enter your email"
                            [ngClass]="{ 'is-invalid': pwdSubmitted && pf.emailid.errors }"
                        />
                        <span class="fa fa-envelope signin-form-icon"></span>
                        <div *ngIf="pwdSubmitted && pf.emailid.errors" class="invalid-feedback">
                            <div *ngIf="pf.emailid.errors.required">Email ID is required</div>
                            <div *ngIf="pf.emailid.errors.email">Email ID is invalid!</div>
                        </div>
                    </div>
                    <div class="form-actions">
                        <button
                            [disabled]="pwdLoading"
                            class="btn signin-btn bg-primary"
                            (click)="forgotPwd()"
                        >
                            SEND PASSWORD RESET LINK
                        </button>
                        <img
                            *ngIf="pwdLoading"
                            class="ps-3"
                            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                        />
                        <!--a routerLink="/register" class="btn btn-link">Register</a-->
                    </div>
                </form>
            </div>
            <!-- Forgot Password Form -->
        </div>
        <!-- Right side / Signin Form -->
    </div>
    <!-- signin-container -->

    <div class="not-a-member">
        Interested to know more - <a href="https://www.streamz.ai/">www.streamz.ai</a>
    </div>
</div>
